function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.25 17.0625V14.625C16.25 14.1763 15.8862 13.8125 15.4375 13.8125H11.375C10.9263 13.8125 10.5625 13.4487 10.5625 13C10.5625 12.5513 10.9263 12.1875 11.375 12.1875H15.4375C15.8862 12.1875 16.25 11.8237 16.25 11.375V10.5625C16.25 10.1138 15.8862 9.75 15.4375 9.75H9.75C9.30127 9.75 8.9375 9.38623 8.9375 8.9375C8.9375 8.48877 9.30127 8.125 9.75 8.125H15.4375C15.8862 8.125 16.25 7.76123 16.25 7.3125C16.25 5.96631 15.1587 4.875 13.8125 4.875H2.4375C1.09131 4.875 0 5.96631 0 7.3125V38.1875C0 38.6362 0.363769 39 0.8125 39H2.4375C2.88623 39 3.25 38.6362 3.25 38.1875V34.125C3.25 33.6763 3.61377 33.3125 4.0625 33.3125H7.3125C7.76123 33.3125 8.125 33.6763 8.125 34.125V38.1875C8.125 38.6362 8.48877 39 8.9375 39H10.5625C11.0112 39 11.375 38.6362 11.375 38.1875V21.9375C11.375 19.6938 13.1938 17.875 15.4375 17.875C15.8862 17.875 16.25 17.5112 16.25 17.0625Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.625 24.375H22.75C22.3013 24.375 21.9375 24.0112 21.9375 23.5625C21.9375 23.1138 22.3013 22.75 22.75 22.75H27.4073C27.6972 22.7494 27.9649 22.5943 28.1097 22.343C28.2544 22.0918 28.2542 21.7824 28.1093 21.5312C27.6741 20.7776 26.8702 20.3131 26 20.3125H16.25C14.9038 20.3125 13.8125 21.4038 13.8125 22.75V38.1875C13.8125 38.6362 14.1763 39 14.625 39H17.875C18.3237 39 18.6875 38.6362 18.6875 38.1875V34.125C18.6875 33.6763 19.0513 33.3125 19.5 33.3125H22.75C23.1987 33.3125 23.5625 33.6763 23.5625 34.125V38.1875C23.5625 38.6362 23.9263 39 24.375 39H27.625C28.0737 39 28.4375 38.6362 28.4375 38.1875V29.25C28.4375 28.8013 28.0737 28.4375 27.625 28.4375H24.375C23.9263 28.4375 23.5625 28.0737 23.5625 27.625C23.5625 27.1763 23.9263 26.8125 24.375 26.8125H27.625C28.0737 26.8125 28.4375 26.4487 28.4375 26V25.1875C28.4375 24.7388 28.0737 24.375 27.625 24.375Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6595 13.4062C31.9031 13.4062 33.722 11.5874 33.722 9.34375C33.722 7.10009 31.9031 5.28125 29.6595 5.28125C27.4158 5.28125 25.597 7.10009 25.597 9.34375C25.597 11.5874 27.4158 13.4062 29.6595 13.4062Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6562 3.65625C30.3293 3.65625 30.875 3.1106 30.875 2.4375V1.21875C30.875 0.545653 30.3293 0 29.6562 0C28.9832 0 28.4375 0.545653 28.4375 1.21875V2.4375C28.4375 3.1106 28.9832 3.65625 29.6562 3.65625Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.5394 5.6875C34.8631 5.688 35.1737 5.55932 35.4022 5.33L36.2635 4.46875C36.7396 3.99264 36.7396 3.22072 36.2635 2.74462C35.7874 2.26852 35.0155 2.26852 34.5394 2.74462L33.6781 3.6075C33.33 3.95604 33.2259 4.47986 33.4144 4.935C33.6029 5.39013 34.0468 5.68706 34.5394 5.6875Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M39 9.34375C39 8.67065 38.4543 8.125 37.7812 8.125H36.5625C35.8894 8.125 35.3438 8.67065 35.3438 9.34375C35.3438 10.0168 35.8894 10.5625 36.5625 10.5625H37.7812C38.4543 10.5625 39 10.0168 39 9.34375Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4023 13.3656C35.0964 13.0486 34.6433 12.9214 34.2172 13.0327C33.791 13.144 33.4581 13.4767 33.3464 13.9027C33.2346 14.3288 33.3615 14.782 33.6781 15.0881L34.5394 15.951C35.0155 16.4271 35.7874 16.4271 36.2635 15.951C36.7396 15.4749 36.7396 14.703 36.2635 14.2269L35.4023 13.3656Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6562 15.0312C28.9832 15.0312 28.4375 15.5769 28.4375 16.25V17.4688C28.4375 18.1418 28.9832 18.6875 29.6562 18.6875C30.3293 18.6875 30.875 18.1418 30.875 17.4688V16.25C30.875 15.5769 30.3293 15.0312 29.6562 15.0312Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M23.049 14.2269C22.741 14.5348 22.6207 14.9837 22.7335 15.4045C22.8462 15.8252 23.1748 16.1538 23.5955 16.2665C24.0162 16.3793 24.4651 16.259 24.7731 15.951L25.6344 15.0881C25.951 14.782 26.0779 14.3288 25.9662 13.9027C25.8544 13.4767 25.5215 13.144 25.0953 13.0327C24.6692 12.9214 24.2161 13.0486 23.9102 13.3656L23.049 14.2269Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5312 10.5625H22.75C23.4231 10.5625 23.9688 10.0168 23.9688 9.34375C23.9688 8.67065 23.4231 8.125 22.75 8.125H21.5312C20.8582 8.125 20.3125 8.67065 20.3125 9.34375C20.3125 10.0168 20.8582 10.5625 21.5312 10.5625Z",
  fill: "black",
  fillOpacity: 0.25
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9103 5.32188C24.2161 5.63884 24.6692 5.76611 25.0953 5.65478C25.5215 5.54344 25.8544 5.21083 25.9662 4.78477C26.0779 4.35872 25.951 3.90552 25.6344 3.59938L24.7731 2.7365C24.4651 2.42852 24.0162 2.30823 23.5955 2.42096C23.1748 2.53369 22.8462 2.86231 22.7335 3.28303C22.6207 3.70374 22.741 4.15264 23.049 4.46063L23.9103 5.32188Z",
  fill: "black",
  fillOpacity: 0.25
});

var SvgCompany5 = function SvgCompany5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompany5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company_5.a6ff7e8f.svg";
export { ForwardRef as ReactComponent };